/**
 * Exact Checkout API key on the variant. Centra named the attribute "final sale",
 * so the payload is `{ "final_sale_final sale": "1" }` when it is set. It was of course an accident naming it this way.
 */
export const FINAL_SALE_ATTRIBUTE_KEY = "final_sale_final sale"
const FINAL_SALE_SET_VALUE = "1"

/** US store (`/en-us`) and US selection country. Both must match. */
export const FINAL_SALE_COUNTRY = "US"

export const isFinalSaleCountry = (countryCode?: string | null): boolean =>
    countryCode?.toUpperCase() === FINAL_SALE_COUNTRY

/**
 * Final-sale notices are US-only: the URL market (`/en-us`) and the country
 * on this Centra selection must both be US. Either one alone is not enough.
 */
export const isFinalSaleCustomer = (
    localeCountry?: string | null,
    selectionCountry?: string | null
): boolean => isFinalSaleCountry(localeCountry) && isFinalSaleCountry(selectionCountry)

/** True when Centra sent `"final_sale_final sale": "1"` on the cart line's variant. */
export const isFinalSaleVariant = (product: unknown): boolean => {
    if (!product || typeof product !== "object") return false
    return (
        (product as Record<string, unknown>)[FINAL_SALE_ATTRIBUTE_KEY] ===
        FINAL_SALE_SET_VALUE
    )
}
